import React from 'react'
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
// import CloseIcon from '@mui/icons-material/Close';

const DoughnutChartComponent = ({doughnutData}) => {
   
    const data = {
      labels: [ 'Total Users', 'Total Devices'],
      datasets: [
        {
          data: [doughnutData.total_users, doughnutData.total_devices],
          backgroundColor: [
            'rgba(30, 60, 114)',
            '#C8D9F1',
           
          ],
          borderColor: [
            'rgba(30, 60, 114)',
            '#C8D9F1',
          ],
          borderWidth: 1,
        },
      ],
    };
   
   
      return <Doughnut
          options={{
            responsive: true,
            maintainAspectRatio: false
          }}
          //width={100}
          //height={50}
          className='dashboardChart'
          data={data} />
  }

export default DoughnutChartComponent
